<template>
  <a :href="whatsappUrl" class="whatsapp-float" target="_blank" :aria-label="$t('openWhatsappButton')" @click="openWhatsApp">
  <i class="fab fa-whatsapp whatsapp-icon"/>
  </a>

</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {CLICK_WHATSAPP_BUTTON, useGtag} from "#imports";
import config from '@/config/config.json';
const { gtag } = useGtag()

export default defineComponent({
  name: "WhatsAppButton",
  data() {
    return {
      whatsappUrl: config.WHATSAPP_URL,
    }
  },
  methods: {
    openWhatsApp() {
      gtag('event', CLICK_WHATSAPP_BUTTON);
    }
  }
})
</script>
<style scoped>
/* Add WA floating button CSS */
.whatsapp-float {
  position: fixed; /* Makes the button fixed on the screen */
  width: 42px; /* Adjust size as needed */
  height: 42px; /* Adjust size as needed */
  bottom: 70px; /* Position from the bottom */
  right: 20px; /* Position from the right */
  background-color: #AA66E4; /* WhatsApp brand color */
  color: #fff;
  border-radius: 50%; /* Makes it a circle */
  text-align: center;
  font-size: 30px; /* Icon size */
  //box-shadow: 2px 2px 3px #999;
  z-index: 100; /* Ensures it stays on top of other content */
  display: flex; /* Centers the icon */
  justify-content: center;
  align-items: center;
  text-decoration: none; /* Removes default link underline */
}

.whatsapp-icon {
  font-size: 22px;
}

.whatsapp-float:hover {
  transform: scale(1.05); /* Optional: Adds a slight hover effect */
  background-color: #753AF3; /* Optional: Slightly darker on hover */
}
</style>